/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { CustomTable, CustomHeaderText, CustomTitle } from 'src/components'
import { VintageItemPayload } from 'src/core/models'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { vintageItemListColumns } from 'src/core/table-columns'
import VintageItemForm from './VintageItemForm/VintageItemForm'
import { setProjectFormItemValue, projectFormStateSelector } from 'src/features'
import { ColumnsType } from 'antd/lib/table'
import { getDateFormattedSmall } from 'src/core/helpers'

const ProjectFormVintageItems: React.FC = () => {
  const dispatch = useAppDispatch()
  const { vintage_items, is_active, kind } = useAppSelector(projectFormStateSelector)

  useEffect(() => {
    if (is_active && vintage_items.some(v => !v.price || v.price <= 0)) {
      dispatch(setProjectFormItemValue({ key: 'is_active', value: false }))
    }
  }, [vintage_items])

  const tableProps = {
    pageSize: 10,
    dataSource: vintage_items,
    rowKey: (vintage: VintageItemPayload) => vintage.year,
    columns: [
      ...(kind !== 'carbon_forward' ? [] : [{
        responsive: ['sm'],
        title: () => <CustomHeaderText text='Forward.DeliveryDate' />,
        render: (_, vintage) => (
          <CustomTitle
            label={`${getDateFormattedSmall(vintage.delivery_date)}`}
            type={null}
          />
        )
      }] as ColumnsType<VintageItemPayload>),
      ...vintageItemListColumns,
    ]
  }

  return (
    <div className='p-5'>
      <VintageItemForm />
      <CustomTable {...tableProps} />
    </div>
  )
}

export default ProjectFormVintageItems
